export enum ErrorCode {
	SUCCESS = 0,
	PENDING_REGISTRATION = 206001,
	PENDING_VERIFICATION = 206002,
	UID_EXISTS = 409001,
	UID_NOT_FOUND = 404003,
	UNAUTHORIZED_USER = 403005,
	// for example accounts.groups.getGroupInfo
	NOT_FOUND = 404000,
	LOGIN_ID_EXISTS = 403043,
	VALIDATION_ERROR = 400009,
	USERNAME_EXISTS = 400003,
	INVALID_API_KEY = 400093,
	CONCURRENT_UPDATES_NOT_ALLOWED = 409030,
	NO_PERMISSION = 403007,
	RATE_LIMIT_HIT = 403048,
	GENERAL_SERVER_ERROR = 500001,
	SEARCH_TIMED_OUT = 504001,
	GROUPS_ASSIGN_USER_USER_ALREADY_PARTY_OF_GROUP = 400006,
	B2B_ACCOUNT_ALREADY_ASSOCIATED_WITH_ORGANIZATION = 400138
}

export default ErrorCode
